import type { IBaseUserModel } from '../models/IBaseUserModel';
import { userAccountStore } from '../stores/auth-store';
import api from './kyAuthenticatedInstance';
import apiUnauthenticated from './kyUnauthenticatedInstance';


export const AuthenticationService = {
	async registerUser(newUser: IBaseUserModel): Promise<IBaseUserModel> {
		return api
			.post(`Account/CreateUser`, {
				json: newUser
			})
			.json<IBaseUserModel>();
	},

	async confirmUser(userId: string, code: string): Promise<Response> {
		return apiUnauthenticated.post(`Account/ConfirmEmail`, {
			json: {
				userId,
				code
			}
		});
	},

	async signOut(): Promise<void> {
		userAccountStore.set({});
	}
};
